module.exports = __webpack_public_path__ + "img/mail-black.e36948ed.svg";